import { FunctionComponent } from 'react';
import awsLogo from '../../../assets/images/aws-logo.svg';
import azureLogo from '../../../assets/images/azure-logo.svg';
import googleCloudLogo from '../../../assets/images/google-cloud-logo.png';
import { CloudEmissionsProvider } from '../shared-services/cloud-emissions/cloud-emissions.model';

// The vendors' marks, unaltered: AWS-Cloud-logo_32.svg from the AWS Architecture Icons package
// (release 07312026) and 10018-icon-service-Azure-A.svg from Microsoft's Azure Public Service
// Icons V24. Both packs are licensed for diagrams and documentation, and both companies'
// trademark guidelines require a licence for logo use in a product; showing them here was an
// explicit business decision on 2026-09-23. Do not recolour, crop or restyle them.
//
// Google Cloud's mark is super_cloud_gradient.png (192 x 192) from www.gstatic.com/cgc, the app
// icon cloud.google.com serves; Google's own icon packs do not include the logo itself. Google's
// brand terms likewise require permission for logo use in a product; showing it here was an
// explicit business decision on 2026-09-30. Do not recolour, crop or restyle it.
const LOGOS: Record<CloudEmissionsProvider, { src: string, alt: string }> = {
  'aws-sustainability': { src: awsLogo, alt: 'AWS' },
  'azure-carbon': { src: azureLogo, alt: 'Microsoft Azure' },
  'google-cloud-carbon': { src: googleCloudLogo, alt: 'Google Cloud' },
};

/**
 * A cloud vendor's logo at a fixed square size. The box is reserved with CSS width and
 * height so the tile or heading never reflows while the image loads.
 */
export const CloudProviderLogo: FunctionComponent<{ provider: CloudEmissionsProvider, size?: number }> = ({ provider, size = 64 }) => {
  const { src, alt } = LOGOS[provider];
  return <img src={src} alt={alt} style={{ width: size, height: size, display: 'block' }} />;
};
